export const APP_URL = process.env.APP_URL;
export const URL_ASGARD = process.env.REACT_APP_ASGARD;
export const URL_ASGARDEXT = process.env.REACT_APP_ASGARD_EXT;
export const URL_NEWS = process.env.REACT_APP_NEWS;